module.exports = __webpack_public_path__ + "img/1L1.7a11e6cc.png";